import React, { useState, useEffect, useRef } from "react";
import "./AdminPackage.css";
import NewHeader from "../NewHeader/NewHeader";
import Modal from "react-modal";
import { Helmet } from "react-helmet";
import "react-google-flight-datepicker/dist/main.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faAddressBook } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import Slider from "react-slider-modal";
import AccomodationListingPopup from "./AccomodationListingPopup";
import ExperienceListingPopup from "./ExperienceListingPopup";
import ExperienceTransferListingPopup from "./ExperienceTransferListingPopup";
import ExperienceTransferFerryListingPopup from "./ExperienceTransferFerryListingPopup";
import VerticalTabsScrollable from "./VerticalTabsScrollable";
import {
  getAdminPackageDetails,
  getAdminPackageDetailsListing,
  SupplierUrl,
  getAdminPackageExprerianceDelete,
  getAdminPackageAccomodationDelete,
} from "../axios";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { removeToCart, clearToCart } from "../../redux/actions/actions";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";
import InvoiceItinerary from "./InvoiceItinerary/Invoice";
import Tab from "@material-ui/core/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import Summarydetails from "./Summarydetails";
import Policydetails from "./Policydetails";



function AdminViewPackageDetails() {
 // const selectedData = useSelector((state) => state.cardItems.cardData);
  const dispatch = useDispatch();
  const [cookies, setCookie] = useCookies(["userDetails"]);
  const [startDate, setstartDate] = useState(null);
  const [endDate, setendDate] = useState(null);
  const [slideShow, setslideShow] = useState(false);
  const [slideExperienceShow, setslideExperienceShow] = useState(false);
  const [
    slideExperienceTransferShow,
    setslideExperienceTransferShow,
  ] = useState(false);
  const [
    slideExperienceTransferFerryShow,
    setslideExperienceTransferFerryShow,
  ] = useState(false);

  const [cats, setcats] = useState([
    { adultCounter: 1, childCounter: 0, roomCounter: 1, isExpanded: true },
  ]);
  const [itineraryPlan, setitineraryPlan] = useState([]);
  const [addMoreLocation, setaddMoreLocation] = useState([]);
  const [changeDate, setchangeDate] = useState([]);
  const [planname, setplanname] = useState("");
  const [selectedStartLocation, setselectedStartLocation] = useState("");
  const [selectedEndLocation, setselectedEndLocation] = useState("");
  const [totalDays, settotalDays] = useState("");
  const [totalLocation, settotalLocation] = useState("");
  const [plandate, setplandate] = useState([]);
  const [itineraryDetails, setitineraryDetails] = useState([]);
  const [DatesOfDay, setDatesOfDay] = useState([]);
  const [tabData, setTabData] = useState([]);
  const [summaryTabData, setSummaryTabData] = useState([]);
  const [activityRequest, setactivityRequest] = useState({});
  const [transferRequest, settransferRequest] = useState({});
  const [transferFerryRequest, settransferFerryRequest] = useState({});
  const [accommodationRequest, setaccommodationRequest] = useState({});
  const [selectedDate, setSelectedDate] = useState([]);
  const [openModal, setopenModal] = useState(false);
  const [reduxData, setreduxData] = useState(null);
  const [checkAvailData, setcheckAvailData] = useState(null);
  const [customerDetails, setcustomerDetails] = useState(
    localStorage.getItem("userDetails") || "abc"
  );
  const [value, setValue] = useState("1");
  const [modalIsOpen, setmodalIsOpen] = useState(false);
  const [EmailId, setEmailId] = useState();
  const [EmailError, setEmailError] = useState(false);
  const [openPlanModal, setopenPlanModal] = useState(false);
  const [tripPlanNameValue, setTripPlanNameValue] = useState("");
  const [tripPlanNameErrorMessage, setTripPlanNameErrorMessage] = useState("");
  const [servicedate, setServicedate] = useState([]);
  const [openModalShare, setopenModalShare] = useState(false);
  const [packageID, setPackageID] = useState();
  const [packageName, setPackageName] = useState("");
  const [packageData, setPackageData] = useState([]);
  const validEmailRegex = RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
  
    const package_id = urlParams.get("package_id");

    getAdminPackageDetails(package_id).then(
      (data) => {
      
    });

    getAdminPackageDetailsListing(package_id).then(
      (data) => {
        setPackageData(data);
      },
      (error) => {}
    );

  }, []);

  // useEffect(() => {
  //   // if (!packageData) return;
   
  //   setPackageName(packageData?.package_name || "");
  //   setstartDate(packageData?.start_date || "");
  //   setendDate(packageData?.end_date || "");
  //   setPackageID(packageData?.package_id || "");
  
  //   // Set guest combination and planning data
  //   const defaultPlanningData = packageData?.planning_data || [];
  //   const guestCombination = packageData?.guest_combination || [];
  //   setaddMoreLocation(defaultPlanningData);
  //   setcats(guestCombination);
  
  //   if (Array.isArray(defaultPlanningData)) {
  //     defaultPlanningData.forEach((itemPlan) => {
  //       // Set total days
  //       settotalDays(itemPlan?.numberOfDay || 0);
    
  //       // Set total locations
  //       settotalLocation(itemPlan?.numberOfLocation || 0);
    
  //       // Set itinerary details
  //       const childrenDetails = itemPlan?.children?.map((child) => ({
  //         id: child?.Id || 0,
  //         location: child?.Location?.label || "Unknown Location",
  //         name: child?.name || 0,
  //         range: child?.range?.map((rangeItem) => ({
  //           number: rangeItem?.number || 0,
  //           startDate: rangeItem?.startDate || "",
  //           endDate: rangeItem?.endDate || "",
  //           indexId: rangeItem?.indexid || 0,
  //         })) || [],
  //       })) || [];
  //   console.log("Ranjeet",childrenDetails);
  //       setitineraryDetails(childrenDetails);
  //     });
  //    } 
  //   // else {
  //   //   console.error("defaultPlanningData is not an array:", defaultPlanningData);
  //   // }
    
  
  //   // Generate dates range
  //   const startMainDate = new Date(packageData?.start_date);
  //   const endDateMain = new Date(packageData?.end_date);
  //   const currentDate = new Date(startMainDate);
  
  //   if (!isNaN(startMainDate) && !isNaN(endDateMain)) {
  //     const datesToRender = [];
  //     while (currentDate <= endDateMain) {
  //       datesToRender.push(new Date(currentDate));
  //       currentDate.setDate(currentDate.getDate() + 1);
  //     }
  //     setDatesOfDay(datesToRender);
  //   }
  // }, [packageData]);
  
  useEffect(() => {
    if (!packageData) return; // early exit if packageData is missing
  
    setPackageName(packageData?.package_name || "");
    setstartDate(packageData?.start_date || "");
    setendDate(packageData?.end_date || "");
    setPackageID(packageData?.package_id || "");
  
    // Set guest combination and planning data
   
    const guestCombination = packageData?.guest_combination || [];
    //setaddMoreLocation(defaultPlanningData);
    setcats(guestCombination);
    const response_planning = packageData?.planning_data; // <~ Array with [] tag
    const jsonObject = JSON.stringify(response_planning);
  //  const defaultPlanningDataString12 = jsonObject;
   // const defaultPlanningDataString1 = jsonObject;
   //console.log(defaultPlanningDataString1);
  const defaultPlanningDataString12 = "[{\"cat\":[{\"adultCounter\":\"2\",\"childCounter\":0,\"roomCounter\":1,\"isExpanded\":false},{\"adultCounter\":1,\"childCounter\":0,\"roomCounter\":1,\"isExpanded\":true}],\"Planname\":\"\\\"Mahe Island\\\", \\\"Praslin Island\\\" - (Mon, 14 Apr 2025 - Fri, 18 Apr 2025)\",\"range\":[{\"startDate\":\"2025-04-14\",\"endDate\":\"2025-04-18\"}],\"numberOfDay\":4,\"numberOfLocation\":2,\"children\":[{\"Id\":0,\"Location\":{\"id\":0,\"label\":\"Mahe Island\"},\"name\":2,\"range\":[{\"number\":2,\"startDate\":\"2025-04-14\",\"endDate\":\"2025-04-16\",\"indexid\":0}]},{\"Id\":1,\"Location\":{\"id\":1,\"label\":\"Praslin Island\"},\"name\":2,\"range\":[{\"number\":2,\"startDate\":\"2025-04-16\",\"endDate\":\"2025-04-18\",\"indexid\":1}]}]}]";

  const defaultPlanningDataString1 =  JSON.parse(defaultPlanningDataString12);
   
    if (defaultPlanningDataString1 !=undefined) {
      // Initialize variables for totals
      let totalDays = 0;
      let totalLocations = 0;
      const allItineraryDetails = [];
    
      // Process each plan
      defaultPlanningDataString1 !=undefined && defaultPlanningDataString1 .forEach((itemPlan) => {
        // Accumulate total days and locations
        totalDays += itemPlan?.numberOfDay || 0;
        totalLocations += itemPlan?.numberOfLocation || 0;
    
        // Map children details
        const childrenDetails = itemPlan?.children?.map((child) => ({
          id: child?.Id || 0,
          location: child?.Location?.label || "Unknown Location",
          name: child?.name || "Unknown Name",
          range:
            child?.range?.map((rangeItem) => ({
              number: rangeItem?.number || 0,
              startDate: rangeItem?.startDate || "",
              endDate: rangeItem?.endDate || "",
              indexId: rangeItem?.indexid || 0,
            })) || [],
        })) || [];
    
        // Collect all children details
        allItineraryDetails.push(...childrenDetails);
      });
    
      // Update states
      settotalDays(totalDays);
      settotalLocation(totalLocations);
      setitineraryDetails(allItineraryDetails);
    
      
    } else {
     
      settotalDays(0);
      settotalLocation(0);
      setitineraryDetails([]);
    }
    

  
    // Generate date range
    const startMainDate = new Date(packageData?.start_date);
    const endDateMain = new Date(packageData?.end_date);
    const currentDate = new Date(startMainDate);
  
    if (!isNaN(startMainDate) && !isNaN(endDateMain)) {
      const datesToRender = [];
      while (currentDate <= endDateMain) {
        datesToRender.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }
      setDatesOfDay(datesToRender);
    }
  }, [packageData?.planning_data]); 
  
  useEffect(() => {
    const savedValue = localStorage.getItem("accomodationSlide");

    if (savedValue === true) {
      setslideShow(true);
    } else {
      setslideShow(false);
    }
  }, [localStorage.getItem("accomodationSlide")]);

  useEffect(() => {
    const attractionValue = localStorage.getItem("attractionSlide");

    if (attractionValue === true) {
      setslideExperienceShow(true);
    } else {
      setslideExperienceShow(false);
    }
  }, [localStorage.getItem("attractionSlide")]);

  useEffect(() => {
    const transferFerryValue = localStorage.getItem("transferFerrySlide");
    if (transferFerryValue === true) {
      setslideExperienceTransferFerryShow(true);
    } else {
      setslideExperienceTransferFerryShow(false);
    }
  }, [localStorage.getItem("transferFerrySlide")]);

  useEffect(() => {
    const transferValue = localStorage.getItem("transferSlide");
    if (transferValue === true) {
      setslideExperienceTransferShow(true);
    } else {
      setslideExperienceTransferShow(false);
    }
  }, [localStorage.getItem("transferSlide")]);

  useEffect(() => {
    if (selectedDate.length > 0) {
      const serviceDateNew =
        selectedDate.length > 0 &&
        selectedDate.reduce(function (a, b) {
          return a < b ? a : b;
        });
      setServicedate(serviceDateNew);
    }
  }, [selectedDate]);
  const PopuphandleCloseClick = () => {
    setslideShow(false);
    localStorage.setItem("accomodationSlide", false);
  };
  const PopupItineraryDetails = () => {
    return (
      <>
        <AccomodationListingPopup
          accommodation={accommodationRequest}
        ></AccomodationListingPopup>
      </>
    );
  };
  const PopuphandleAccomodationListingClick = (
    accoDetails,
    IndexNumber = null
  ) => {
    setslideShow(true);
    let JsonState = {
      defaultZoneval: accoDetails?.Location?.label,
      startDate: moment(accoDetails.range[0].startDate).format("Y-MM-DD"),
      endDate: moment(accoDetails.range[0].endDate).format("Y-MM-DD"),
      guestCombination: cats,
      accopage: 1,
      accosize: 30,
      IndexNumber: IndexNumber,
      package_id: packageID,
    };
    const hotelArr = JSON.stringify(JsonState);

    setaccommodationRequest(hotelArr);
  };

  const PopupExperiencehandleCloseClick = () => {
    setslideExperienceShow(false);
    localStorage.setItem("attractionSlide", false);
  };
  const PopupExperienceItinerary = () => {
    return (
      <>
        <ExperienceListingPopup
          experience={activityRequest}
        ></ExperienceListingPopup>
      </>
    );
  };
  const PopuphandleExperienceListingClick = (
    selectedDate,
    defaultZoneval,
    IndexNumber = null
  ) => {
    setslideExperienceShow(true);
    let JsonActivity = {
      defaultZonevalActivityVal: defaultZoneval,
      dateSelected: moment(selectedDate).format("Y-MM-DD"),
      activitypage: 1,
      activitysize: 1,
      IndexNumber: IndexNumber,
      package_id: packageID,
      guestCombination: cats,
    };

    let activityArr = JSON.stringify(JsonActivity);
    setactivityRequest(activityArr);
  };

  const PopupExperienceTransferItinerary = () => {
    return (
      <>
        <ExperienceTransferListingPopup
          experiencetransfer={transferRequest}
        ></ExperienceTransferListingPopup>
      </>
    );
  };
  const PopuphandleExperienceTransferListingClick = (
    selectedDate,
    defaultZoneval,
    otherLocation = null,
    IndexNumber = null
  ) => {
    setslideExperienceTransferShow(true);
    let locationData = "";

    if (otherLocation != null) {
      locationData = [defaultZoneval, otherLocation];
    } else {
      locationData = [defaultZoneval];
    }

    let JsonActivity = {
      defaultZonevalTransferVal: locationData,
      dateSelected: moment(selectedDate).format("Y-MM-DD"),
      activitypage: 1,
      activitysize: 1,
      IndexNumber: IndexNumber,
      package_id: packageID,
      guestCombination: cats,
    };
    let transferArr = JSON.stringify(JsonActivity);
    settransferRequest(transferArr);
  };

  const PopupExperienceTransferhandleCloseClick = () => {
    setslideExperienceTransferShow(false);
    localStorage.setItem("transferSlide", false);
  };

  //Ferry Transfer Details

  const PopupExperienceTransferFerryItinerary = () => {
    return (
      <>
        <ExperienceTransferFerryListingPopup
          experiencetransfer={transferFerryRequest}
        ></ExperienceTransferFerryListingPopup>
      </>
    );
  };
  const PopuphandleExperienceTransferFerryListingClick = (
    selectedDate,
    defaultZoneval,
    IndexNumber = null
  ) => {
    setslideExperienceTransferFerryShow(true);
    let JsonActivity = {
      defaultZonevalTransferVal: defaultZoneval,
      dateSelected: moment(selectedDate).format("Y-MM-DD"),
      activitypage: 1,
      activitysize: 1,
      IndexNumber: IndexNumber,
      package_id: packageID,
      guestCombination: cats,
    };

    let transferArr = JSON.stringify(JsonActivity);
    settransferFerryRequest(transferArr);
  };

  const PopupExperienceTransferFerryhandleCloseClick = () => {
    setslideExperienceTransferFerryShow(false);
    localStorage.setItem("transferFerrySlide", false);
  };

  useEffect(() => {
   
    const resultData = [];
    DatesOfDay.length > 0 &&
      DatesOfDay.map((sequenceDate, indexData) => {
        // let Accomodationinput = itineraryDetails.find(
        //   (y) =>
        //     moment(y.range[0].startDate).format("Y-MM-DD") <=
        //       moment(sequenceDate).format("Y-MM-DD") &&
        //     moment(y.range[0].endDate).format("Y-MM-DD") >
        //       moment(sequenceDate).format("Y-MM-DD")
        // );
        // let itineraryinput = itineraryDetails.find(
        //   (y) =>
        //     moment(y.range[0].startDate).format("Y-MM-DD") <=
        //       moment(sequenceDate).format("Y-MM-DD") &&
        //     moment(y.range[0].endDate).format("Y-MM-DD") >=
        //       moment(sequenceDate).format("Y-MM-DD")
        // );
  
        // Assuming `sequenceDate` is already defined
        let Accomodationinput = itineraryDetails.find(
          (y) => 
            moment(y.range[0].startDate).format("YYYY-MM-DD") <= moment(sequenceDate).format("YYYY-MM-DD") &&
            moment(y.range[0].endDate).format("YYYY-MM-DD") > moment(sequenceDate).format("YYYY-MM-DD")
        );
        
        let itineraryinput = itineraryDetails.find(
          (y) => 
            moment(y.range[0].startDate).format("YYYY-MM-DD") <= moment(sequenceDate).format("YYYY-MM-DD") &&
            moment(y.range[0].endDate).format("YYYY-MM-DD") >= moment(sequenceDate).format("YYYY-MM-DD")
        );
        
        console.log('Accommodation Input:', Accomodationinput);
        console.log('Itinerary Input:', itineraryinput);
        
        resultData.push({
          label: moment(sequenceDate).format("DD MMM Y"),

          content: (
            <div class="dayplan-wrapper" data-testid="day-plan-wrapper">
              <div id={`dayplan${indexData}`} day={indexData}></div>
              <div class="dayplan-header">
                <p class="dayplan-title">
                  Day {indexData + 1} - {itineraryinput?.location}{" "}
                  {Accomodationinput?.location !=
                    itineraryinput?.location && (
                    <> - {Accomodationinput?.location}</>
                  )}
                </p>
                <div class="day-plan-incusions-container">
                 
                  <div class="day-plan-inclusions">
                    <ul>
                      <li>
                        <span class="holidaySprite icon24 dayPlanHotelIcon"></span>
                        <span>
                          {Array.isArray(packageData?.accomodation)
                            ? packageData.accomodation.filter((item) => {
                                return (
                                  moment(item.start_date).format("Y-MM-DD") <=
                                    moment(sequenceDate).format("Y-MM-DD") &&
                                  moment(item.end_date).format("Y-MM-DD") >
                                    moment(sequenceDate).format("Y-MM-DD")
                                );
                              }).length
                            : 0}
                          &nbsp;Hotels
                        </span>
                      </li>
                      <li>
                        <span class="holidaySprite icon24 dayPlanTransferIcon"></span>
                        <span>
                          {Array.isArray(packageData?.landtransfer)
                            ? packageData.landtransfer.filter(
                                (item) =>
                                  moment(item.start_date).format("Y-MM-DD") ===
                                  moment(sequenceDate).format("Y-MM-DD")
                              ).length
                            : 0}
                          &nbsp;Land Transfer
                        </span>
                      </li>
                      <li>
                        <span class="holidaySprite icon24 dayPlanActivityIcon"></span>
                        <span>
                          {Array.isArray(packageData?.attraction)
                            ? packageData.attraction.filter(
                                (item) =>
                                  moment(item.start_date).format("Y-MM-DD") ===
                                  moment(sequenceDate).format("Y-MM-DD")
                              ).length
                            : 0}
                          &nbsp;Activity
                        </span>
                      </li>
                      <li>
                        <span class="holidaySprite icon24 dayPlanActivityIcon"></span>
                        <span>
                          {Array.isArray(packageData?.ferrytransfer)
                            ? packageData.ferrytransfer.filter(
                                (item) =>
                                  moment(item.start_date).format("Y-MM-DD") ===
                                  moment(sequenceDate).format("Y-MM-DD")
                              ).length
                            : 0}
                          &nbsp;Ferry Transfer
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                class="dayplan-section"
                data-testid="day-plan-section-flight"
              >
                <div>
                  <div class="flightListRow flexOne column">
                    <div class="makeFlex">
                      <ul class="flight-row firstFlightRow"></ul>
                    </div>
                  </div>
                </div>
              </div>

              {Array.isArray(packageData?.accomodation) &&
              packageData?.accomodation.length > 0 ? (
                packageData?.accomodation.map((i, j) => {
                  let DataValue = "";
                  if (
                    moment(i.start_date).format("Y-MM-DD") <=
                      moment(sequenceDate).format("Y-MM-DD") &&
                    moment(i.end_date).format("Y-MM-DD") >
                      moment(sequenceDate).format("Y-MM-DD")
                  ) {
                    DataValue = (
                      <>
                        <div
                          class="dayplan-section"
                          data-testid="day-plan-section-hotel"
                        >
                          <div class="hotel-row-wrapper ">
                            <div
                              class="hotel-row highlight "
                              data-testid="hotel"
                            >
                              <div class="hotel-row-header">
                                <div class="hotel-header-row-lhs">
                                  <div class="hotel-header-details"><span class=" latoBold"></span>
                                  <span class="latoBold font14">Accommodations</span>
                                  <span class="header-span "></span>
                                  <span class=" font14">
                                    </span><span class="header-span "></span><span class=" font14">
                                      </span><span class="mmt-chevron-up"></span>
                                  <span class="font14 headerPriority">Priority {i.property_sequence}</span><span class="mmt-chevron-up"></span></div></div>
                                <div
                                  data-testid="changeRemoveBtn_hotel"
                                  id="changeRemoveBtn"
                                  class="hotel-row-btns"
                                >
                                  <span
                                    id="remove"
                                    onClick={() =>
                                      handleRemoveAccommodation(i?.id)
                                    }
                                  >
                                    Remove
                                  </span>
                                 
                                </div>
                              </div>
                              <div class="hotel-row-body">
                                <div class="hotel-row-image-wrapper">
                                 
                                  <div class=" image-carousel-slide ">
                                    <div
                                      class="imageLoaderContainer "
                                      style={{
                                        width: "243px",
                                        height: "144px",
                                      }}
                                    >
                                      <img
                                        class="borderRadius4 vrtTop active "
                                        width="243"
                                        height="144"
                                        src={`${SupplierUrl}/uploads/room_gallery_main/${i.gallery_image[0].image}`}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="hotel-row-details">
                                  <p class="hotel-row-details-title">
                                    {i.property_name}
                                    <span class="holidaySprite rating_blank">
                                      <span class="holidaySprite rating_fill ratingThree"></span>
                                    </span>
                                  </p>
                                  <p class="hotel-row-text-sm">
                                    {i?.address_line_1}
                                  </p>
                                 
                                  <p class="hotel-row-text-date">
                                    <FontAwesomeIcon
                                      icon={faClock}
                                      class="holidaySprite hotelCardCalendar"
                                    />
                                    {moment(i.start_date).format("D MMM Y")}, {i.check_in} -{" "} 
                                    {moment(i.end_date).format("D MMM Y")}, {i.check_out}
                                  </p>

                                  
                                  <div className="listingPrice">
                                <p
                                  className="latoBlack font14 blackText appendBottom5">
                                  <span>€</span>
                                  {i.price}
                                </p>
                                </div>
                                <div class="hotel-details-lower-section">
                                {i?.room_rateplan.map((k, v) => {
                                 
                                 return(
                                  <div>
                                  <div class="lower-section-header-cx">{k.room_name}</div>
                                  <div class="breakfast-inclusion-cx">
                                    <div class="breakfast-cx"><div class="rateplan-otherinfo-img"><FontAwesomeIcon
                                      icon={faAddressBook}
                                      class="holidaySprite hotelCardCalendar"
                                    /></div><p class="appendLeft5">{k.rate_plan_name}, {k.adult_count && `Adult ${k.adult_count}`} {k.child_count && `Child ${k.child_count}`}</p></div>
                                  <div class="inclusions-list"></div></div>
                                  </div>
                               )})}
                                  
                                  </div>
                                </div>
                              </div>
                              
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  }
                  {
                    return <>{DataValue}</>;
                  }
                })
              ) : (
                <>
                 
                </>
              )}

              <div
                class="dayplan-section"
                data-testid="day-plan-section-flight"
              >
                <div>
                  <div class="flightListRow flexOne column">
                    <div class="makeFlex">
                      <ul class="flight-row firstFlightRow"></ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="add-activity-container">
                <div class="add-activity-card">
                  <p class="add-activity-quote">
                    Choose your ideal accommodation for a memorable stay, sorted
                    out by location, special offers applied instantly.
                  </p>
                </div>
                <div
                  id="chooseAndAddBtn"
                  class="add-activity-button"
                  data-testid="add-activity-button"
                  onClick={() =>
                    PopuphandleAccomodationListingClick(Accomodationinput)
                  }
                >
                  <span class="holidaySprite activityIcon"></span>ADD
                  ACCOMMODATIONS
                </div>
              </div>
              
              <div
                class="dayplan-section"
                data-testid="day-plan-section-transfer"
              >
                <div class="add-activity-container">
                  <div class="add-activity-card">
                    <p class="add-activity-quote">
                      Craft your perfect itinerary! Connect the dots with
                      convenient transfers.
                    </p>
                  </div>
                  <div
                    id="chooseAndAddBtn"
                    class="add-activity-button"
                    data-testid="add-activity-button"
                    onClick={() =>
                      PopuphandleExperienceTransferListingClick(
                        sequenceDate,
                        itineraryinput?.Location?.label,
                        selectedStartLocation != "" && indexData == 0
                          ? selectedStartLocation
                          : selectedEndLocation != "" &&
                            DatesOfDay.length == indexData + 1
                          ? selectedEndLocation
                          : null
                      )
                    }
                  >
                    <span class="holidaySprite activityIcon"></span>
                    ADD LAND TRANSFER
                  </div>
                </div>
              </div>

              {Array.isArray(packageData?.landtransfer) &&
              packageData?.landtransfer.length > 0 ? (
                packageData?.landtransfer.map((i, j) => {
                  let dateselected = new Date(i.start_date);
                  let DataValue = "";

                  if (
                    moment(dateselected).format("Y-MM-DD") ===
                    moment(sequenceDate).format("Y-MM-DD")
                  ) {
                    DataValue = (
                      <>
                        {" "}
                        <div
                          class="dayplan-section"
                          data-testid="day-plan-section-transfer"
                        >
                          <div
                            class="transfer-row highlight "
                            data-testid="transfer"
                          >
                            <div class="transfer-row-header">
                            
                              <div class="hotel-header-row-lhs">
                                  <div class="hotel-header-details"><span class=" latoBold"></span>
                                  <span class="latoBold font14">Land Transfer</span>
                                  <span class="header-span "></span>
                                  <span class=" font14">
                                    </span><span class="header-span "></span><span class=" font14">
                                      </span><span class="mmt-chevron-up"></span>
                                  <span class="font14 headerPriority">Priority {i.experience_sequence}</span><span class="mmt-chevron-up"></span></div></div>
                              <div
                                id="changeRemoveBtn"
                                class="transfer-row-btns"
                              >
                                <span
                                  id="remove"
                                  onClick={() => handleRemoveExperience(i?.id)}
                                >
                                  Remove
                                </span>
                              
                              </div>
                            </div>
                            <div class="transfer-row-body">
                              <div class="transfer-row-image-wrapper">
                                <div class=" image-carousel-slide ">
                                  <div
                                    class="imageLoaderContainer "
                                    style={{
                                      width: "243px",
                                      height: "144px",
                                    }}
                                  >
                                    <img
                                      class="borderRadius4 vrtTop active "
                                      width="243"
                                      height="144"
                                      src={i.gallery_image[0]}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="hotel-row-details">
                                <p class="hotel-row-details-title">
                                  {i.tour_name}
                                  <span class="holidaySprite rating_blank">
                                    <span class="holidaySprite rating_fill ratingThree"></span>
                                  </span>
                                </p>
                                <p class="hotel-row-text-sm">
                                  {i.tour_location}
                                </p>
                                
                                <p class="hotel-row-text-date">
                                  <FontAwesomeIcon
                                    icon={faClock}
                                    class="holidaySprite hotelCardCalendar"
                                  />
                                  {moment(i.start_date).format("D MMM Y")}{" "}
                                  {i.experience_time != ""
                                    ? i.experience_time
                                    : "cordinate"}
                                </p>

                               
                                  <div className="listingPrice">
                                <p
                                  className="latoBlack font14 blackText appendBottom5">
                                  <span>€</span>
                                  {i.price}
                                </p>
                                </div>
                                <div class="hotel-details-lower-section"><div>
                                  <div class="lower-section-header-cx">{i.option_name}</div>
                                  <div class="breakfast-inclusion-cx">
                                   
                                  <div class="inclusions-list"></div></div>
                                  </div>
                                  {/* <a class="change-room-linkV2">More</a> */}
                                  </div>
                              </div>
                             
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  }

                  {
                    return <>{DataValue}</>;
                  }
                })
              ) : (
                <></>
              )}

              {/* Ferry Transfer */}

              <div
                class="dayplan-section"
                data-testid="day-plan-section-transfer"
              >
                <div class="add-activity-container">
                  <div class="add-activity-card">
                    <p class="add-activity-quote">
                      Visit other islands: Add ferry to your island-hopping
                      trip.
                    </p>
                  </div>
                  <div
                    id="chooseAndAddBtn"
                    class="add-activity-button"
                    data-testid="add-activity-button"
                    onClick={() =>
                      PopuphandleExperienceTransferFerryListingClick(
                        sequenceDate,
                        itineraryinput?.Location?.label
                      )
                    }
                  >
                    <span class="holidaySprite activityIcon"></span>
                    ADD FERRY
                  </div>
                </div>
              </div>

              {Array.isArray(packageData?.ferrytransfer) &&
              packageData?.ferrytransfer.length > 0 ? (
                packageData?.ferrytransfer.map((i, j) => {
                  let dateselected = new Date(i.start_date);
                  let DataValue = "";
                  if (
                    moment(dateselected).format("Y-MM-DD") ===
                    moment(sequenceDate).format("Y-MM-DD")
                  ) {
                    DataValue = (
                      <>
                        {" "}
                        <div
                          class="dayplan-section"
                          data-testid="day-plan-section-transfer"
                        >
                          <div
                            class="transfer-row highlight "
                            data-testid="transfer"
                          >
                            <div class="transfer-row-header">
                            
                              <div class="hotel-header-row-lhs">
                                  <div class="hotel-header-details"><span class=" latoBold"></span>
                                  <span class="latoBold font14">Ferry Transfer</span>
                                  <span class="header-span "></span>
                                  <span class=" font14">
                                    </span><span class="header-span "></span><span class=" font14">
                                      </span><span class="mmt-chevron-up"></span>
                                  <span class="font14 headerPriority">Priority {i.experience_sequence}</span><span class="mmt-chevron-up"></span></div></div>
                              <div
                                id="changeRemoveBtn"
                                class="transfer-row-btns"
                              >
                                <span
                                  id="remove"
                                  onClick={() => handleRemoveExperience(i?.id)}
                                >
                                  Remove
                                </span>
                               
                              </div>
                            </div>
                            <div class="transfer-row-body">
                              <figure class="transfer-row-image-wrapper">
                                <div class=" image-carousel-slide ">
                                  <div
                                    class="imageLoaderContainer "
                                    style={{
                                      width: "243px",
                                      height: "144px",
                                    }}
                                  >
                                    <img
                                      class="borderRadius4 vrtTop active "
                                      width="243"
                                      height="144"
                                      src={i.gallery_image[0]}
                                    />
                                  </div>
                                </div>
                              </figure>
                             
                              <div class="hotel-row-details">
                                <p class="hotel-row-details-title">
                                  {i.tour_name}
                                  <span class="holidaySprite rating_blank">
                                    <span class="holidaySprite rating_fill ratingThree"></span>
                                  </span>
                                </p>
                                <p class="hotel-row-text-sm">
                                  {i.tour_location}
                                </p>
                               
                                <p class="hotel-row-text-date">
                                  <FontAwesomeIcon
                                    icon={faClock}
                                    class="holidaySprite hotelCardCalendar"
                                  />
                                  {moment(i.start_date).format("D MMM Y")}{" "}
                                  {i.experience_time != ""
                                    ? i.experience_time
                                    : "cordinate"}
                                </p>


                                  <div className="listingPrice">
                                <p
                                  className="latoBlack font14 blackText appendBottom5">
                                  <span>€</span>
                                  {i.price}
                                </p>
                                </div>
                                <div class="hotel-details-lower-section"><div>
                                  <div class="lower-section-header-cx">{i.option_name}</div>
                                  <div class="breakfast-inclusion-cx">
                                    
                                  <div class="inclusions-list"></div></div>
                                  </div>
                                  {/* <a class="change-room-linkV2">More</a> */}
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  }

                  {
                    return <>{DataValue}</>;
                  }
                })
              ) : (
                <></>
              )}
              {/* Attraction Data */}

              <div
                class="dayplan-section"
                data-testid="day-plan-section-activity"
              ></div>
              <div class="add-activity-container">
                <div class="add-activity-card">
                  <p class="add-activity-quote">
                    Add amazing attractions and things to do to your itinerary!
                  </p>
                </div>
                <div
                  id="chooseAndAddBtn"
                  class="add-activity-button"
                  data-testid="add-activity-button"
                  onClick={() =>
                    PopuphandleExperienceListingClick(
                      sequenceDate,
                      itineraryinput?.Location?.label
                    )
                  }
                >
                  <span class="holidaySprite activityIcon"></span>
                  ADD ACTIVITY
                </div>
              </div>
              {Array.isArray(packageData?.attraction) &&
              packageData?.attraction.length > 0 ? (
                packageData?.attraction.map((i, j) => {
                  let dateselected = new Date(i.start_date);
                  let DataValue = "";
                  if (
                    moment(dateselected).format("Y-MM-DD") ===
                    moment(sequenceDate).format("Y-MM-DD")
                  ) {
                    DataValue = (
                      <>
                        {" "}
                        <div
                          class="dayplan-section"
                          data-testid="day-plan-section-transfer"
                        >
                          <div
                            class="transfer-row highlight "
                            data-testid="transfer"
                          >
                            <div class="transfer-row-header">
                              
                              <div class="hotel-header-row-lhs">
                                  <div class="hotel-header-details"><span class=" latoBold"></span>
                                  <span class="latoBold font14">Activity</span>
                                  <span class="header-span "></span>
                                  <span class=" font14">
                                    </span><span class="header-span "></span><span class=" font14">
                                      </span><span class="mmt-chevron-up"></span>
                                  <span class="font14 headerPriority">Priority {i.experience_sequence}</span><span class="mmt-chevron-up"></span></div></div>
                              <div
                                id="changeRemoveBtn"
                                class="transfer-row-btns"
                              >
                                <span
                                  id="remove"
                                  onClick={() => handleRemoveExperience(i.id)}
                                >
                                  Remove
                                </span>
                                
                              </div>
                            </div>
                            <div class="transfer-row-body">
                              <figure class="transfer-row-image-wrapper">
                                <div class=" image-carousel-slide ">
                                  <div
                                    class="imageLoaderContainer "
                                    style={{
                                      width: "243px",
                                      height: "144px",
                                    }}
                                  >
                                    <img
                                      class="borderRadius4 vrtTop active "
                                      width="243"
                                      height="144"
                                      src={i.gallery_image[0]}
                                    />
                                  </div>
                                </div>
                              </figure>
                             
                             <div class="hotel-row-details">
                                <p class="hotel-row-details-title">
                                  {i.tour_name}
                                  <span class="holidaySprite rating_blank">
                                    <span class="holidaySprite rating_fill ratingThree"></span>
                                  </span>
                                </p>
                                <p class="hotel-row-text-sm">
                                  {i.tour_location}
                                </p>
                               
                                <p class="hotel-row-text-date">
                                  <FontAwesomeIcon
                                    icon={faClock}
                                    class="holidaySprite hotelCardCalendar"
                                  />
                                  {moment(i.start_date).format("D MMM Y")}{" "}
                                  {i.experience_time != ""
                                    ? i.experience_time
                                    : "cordinate"}
                                </p>


                                  <div className="listingPrice">
                                <p
                                  className="latoBlack font14 blackText appendBottom5">
                                  <span>€</span>
                                  {i.price}
                                </p>
                                </div>
                                <div class="hotel-details-lower-section"><div>
                                  <div class="lower-section-header-cx">{i.option_name}</div>
                                  <div class="breakfast-inclusion-cx">
                                    
                                  <div class="inclusions-list"></div></div>
                                  </div>
                                  {/* <a class="change-room-linkV2">More</a> */}
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  }

                  {
                    return <>{DataValue}</>;
                  }
                })
              ) : (
                <></>
              )}
            </div>
          ),
        });
      });
    setTabData(resultData);
  }, [DatesOfDay, packageData]);

  useEffect(() => {
    const sortedData = packageData?.summary
  ?.map((item, index) => ({ index, ...item })) // Include the index for stable sorting
  ?.sort((a, b) => {
    const accodata = a.check_in ? moment(a.check_in, "HH:mm a").toDate() : null;
    const accodatb = b.check_in ? moment(b.check_in, "HH:mm a").toDate() : null;

    // Handle null values for check_in
    if (accodata === null && accodatb === null) {
      return a.index - b.index; // Keep original order if both are null
    }
    if (accodata === null) return 1; // Null values go to the end
    if (accodatb === null) return -1;

    // Compare by check_in time
    return accodata - accodatb;
  })
  ?.map(({ index, ...item }) => item); // Remove index after sorting

    const resultSummaryData = [];
    DatesOfDay.length > 0 &&
      DatesOfDay.map((sequenceDate, indexData) => {
        resultSummaryData.push({
          label: moment(sequenceDate).format("DD MMM Y"),

          content: (
            // <div className="dayRowContainer">
            <div class="dayplan-wrapper" data-testid="day-plan-wrapper">
              {Array.isArray(sortedData) &&
              sortedData.length > 0 &&
              sortedData.map((item, index) => {
                  const dateSelected = new Date(item.start_date);
                  let DataValue = "";

                  if (item.TYPE !== "accommodation") {
                    if (
                      moment(dateSelected).format("Y-MM-DD") ===
                      moment(sequenceDate).format("Y-MM-DD")
                    ) {
                      DataValue = (
                        <div className="dayRowContainer" key={index}>
                          <div className="summaryDetailWrapper">
                            <div className="summaryDetailContainer">
                              <span className="font12 hotel-row-text-date-summary">
                                <b>
                                  {item?.check_in ? item?.check_in : "Coordinated Timing"}
                                </b>
                              </span>
                              <span className="font12">
                                {item?.time ? (
                                  <>
                                    {item?.service_name} {item?.full_address}
                                  </>
                                ) : (
                                  <>
                                    Coordinated Timing for <b>{item?.service_name}</b>{" "}
                                    {item?.full_address}: The supplier will contact you to
                                    organize.
                                  </>
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  } else {
                    const startDate = moment(item.start_date).format("Y-MM-DD");
                    const endDate = moment(item.end_date).format("Y-MM-DD");
                    const seqDate = moment(sequenceDate).format("Y-MM-DD");

                    if (startDate <= seqDate && endDate > seqDate) {
                      if (startDate === seqDate) {
                        DataValue = (
                          <div className="dayRowContainer" key={index}>
                            <div className="summaryDetailWrapper">
                              <div className="summaryDetailContainer">
                                <p className="font12 hotel-row-text-date-summary">
                                  <b>
                                    {moment(item.check_in, ["h:mm A"]).format("hh A")}
                                  </b>
                                </p>
                                <span className="font12">
                                  Check-in to <b>{item.service_name}</b> {item.full_address}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    } else if (endDate === seqDate) {
                      DataValue = (
                        <div className="dayRowContainer" key={index}>
                          <div className="summaryDetailWrapper">
                            <div className="summaryDetailContainer">
                              <p className="font12 hotel-row-text-date-summary">
                                <b>
                                  {moment(item.check_out, ["h:mm A"]).format("hh A")}
                                </b>
                              </p>
                              <span className="font12">
                                Check-out from <b>{item.service_name}</b> {item.full_address}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  }

                  return DataValue;
                })}
            </div>
          ),
        });
      });
    setSummaryTabData(resultSummaryData);
  }, [DatesOfDay, packageData.summary]);

  const displayPayment = () => {
   
    return (
      <>
        {/* <p class="font16" style={{ marginBottom: "10px" }}>
          Price with Offers
        </p>
        <p class="slashedPrice">  <span>€</span>
        {packageData?.total_price}</p>
        <p class="font12">
          <span id="price_detail" class="font16 latoBlack">
            <span>€ {packageData?.selling_price}</span>
          </span>{" "}
        </p>
        <p class="font10 greyText">*Including all taxes</p>
      <span class="pakageOfftag">{packageData?.discount_percentage}% OFF</span>  */}
      <div class="pakageDtlWrapTop"><div class="packageDtlslashedOfferPrice"><p class="slashedPrice">€{packageData?.total_price}</p><span class="packageOfftag">{packageData?.discount_percentage}% OFF</span></div><p class="priceContainer"><span class="priceDetail"><span>€{packageData?.selling_price}</span></span> </p><p class="excludingText">Excluding applicable taxes</p> </div>
      </>
    );
  };

  const handleRemoveExperience = (experience_id) => {
    getAdminPackageExprerianceDelete(experience_id).then(
      (data) => {
        window.location.reload(true);
        // setTimeout(() => {
        //   window.location.reload(true);
        // }, 1000);
      },
      (error) => {}
    );
  };
  const handleRemoveAccommodation = (acco_id) => {
    getAdminPackageAccomodationDelete(acco_id).then(
      (data) => {
        window.location.reload(true);
        // setTimeout(() => {
        //   window.location.reload(true);
        // }, 1000);
      },
      (error) => {}
    );
  };
  const handleClear = () => {
    dispatch(clearToCart());
    setTimeout(() => {
      const url =
        "/makepackagebuild?moreLocation=" +
        encodeURIComponent(addMoreLocation) +
        "&checkin=" +
        encodeURIComponent(startDate) +
        "&checkout=" +
        encodeURIComponent(endDate) +
        "&package_id=" +
        encodeURIComponent(packageID) +
        "&guestCombination=" +
        JSON.stringify(cats);
      window.location.replace(url);
    }, 1000);
  };
 
  let closeModal = () => {
    setopenModal(false);
  };

  let ContinuePayment = (e) => {
    checkAvailData != null &&
      checkAvailData.length > 0 &&
      checkAvailData.map((checkData, indexJax) => {
        if (
          checkData.expreience &&
          checkData.expreience[0]["options"][0]["timing"] == "unavailable"
        ) {
          return (
            reduxData != null &&
            reduxData.length > 0 &&
            Object.entries(reduxData).map((i, indexJ) => {
              if (indexJax === indexJ) {
                dispatch(removeToCart(indexJ));
              }
            })
          );
        } else if (
          checkData.accomodation &&
          checkData.accomodation.toString() == "notavil"
        ) {
          return (
            reduxData != null &&
            reduxData.length > 0 &&
            Object.entries(reduxData).map((i, indexJ) => {
              if (indexJax === indexJ) {
                dispatch(removeToCart(indexJ));
              }
            })
          );
        }
      });

    setTimeout(() => {
      const url = "/paymentcart";
      window.location.replace(url);
    }, 1000);
  };

  let loginPage = (e) => {
    e.preventDefault();
    setmodalIsOpen(true);
  };

  let OnChangeTripPlanName = (event) => {
    let tripname = event.target.value;
    let lastregMatch = /^[a-zA-Z0-9 ]*$/.test(event.target.value);
    const sanitizedValue = tripname.replace(/[^\w\s]/gi, ""); // Regex to remove special characters
    if (tripname !== sanitizedValue) {
      setTripPlanNameErrorMessage("Special characters are not allowed.");
    } else if (event.target.value.length <= 3 && lastregMatch) {
      setTripPlanNameErrorMessage("Input must be at least 3 characters long");
    } else if (event.target.value.length >= 50 && lastregMatch) {
      setTripPlanNameErrorMessage("Input must be maximum 50 characters long");
    } else {
      setTripPlanNameErrorMessage("");
    }

    setTripPlanNameValue(tripname);
  };

  let closePlanModal = () => {
    setopenPlanModal(false);
  };
  let AddToTripPlan = (e) => {
    e.preventDefault();
    setopenPlanModal(true);
  };

 
  let openModalShareDiv = () => {
    setopenModalShare(true);
  };

  let closeModalShareDiv = () => {
    setopenModalShare(false);
  };

  let OnChangeEmailId = (event) => {
    const email = validEmailRegex.test(event.target.value);
    if (email == true) {
      setEmailId(event.target.value);
      setEmailError(false);
    } else {
      setEmailId(event.target.value);
      setEmailError(true);
    }
  };

  // let sharePlantrip = (e) => {
  //   let CheckErrorEmail = false;
  //   const email = validEmailRegex.test(EmailId);
  //   if (email == true) {
  //     setEmailError(false);
  //     CheckErrorEmail = true;
  //   } else {
  //     CheckErrorEmail = false;
  //     setEmailError(true);
  //   }
  //   if (CheckErrorEmail == true) {
  //     let reduxdata = JsonStatePDFAcco;
  //     let emailID = EmailId;
  //     let customer = JSON.parse(customerDetails);
  //     let customer_id = customer?.uid;
  //     let selectedNewStartLocation = selectedStartLocation;
  //     let selectedNewEndLocation = selectedEndLocation;

  //     shareItineraryDetails(
  //       reduxdata,
  //       emailID,
  //       customer_id,
  //       selectedNewStartLocation,
  //       selectedNewEndLocation
  //     ).then(
  //       (data) => {
  //         alert("Your Itinerary Plan has submit");
  //         setopenModalShare(false);
  //       },
  //       (error) => {}
  //     );
  //   }
  // };

  return (
    <div className="Detail-container">
      <Helmet>
        <title>Book Best Hotels in seychelles- Holidays Seychelles</title>
        <meta
          name="description"
          content="Book best hotels in Seychelles at affordable prices."
        />
        <meta
          name="keywords"
          content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"
        />
      </Helmet>
      <h1 style={{ color: "#fff" }}>
        Book Best Hotels in seychelles- Holidays Seychelles
      </h1>
      <NewHeader page={"inner"} />
      <TabContext value={value}>
        <div className="topSection newTopSection appendBottom20">
          <div className="pageContainer">
            <div className="appendBottom15 pageHeading">
              <div className="makeFlex">
                <span className="topHeading">{packageName}</span>
              </div>
              <div className="topSubBar">
                <div className="topSubHead">
                  <div className="packageTypeTagV2">
                    <span className="font11  widthMaxContent">
                      {" "}
                      {totalDays}N/{totalDays + 1}D
                    </span>
                  </div>
                  <p className="duration-text">
                    {itineraryDetails.length &&
                      itineraryDetails.map((plan, index) => (
                        <>
                          {`${plan.name}N ${plan?.Location?.label} `}
                          <span className="black-dot"></span>
                        </>
                      ))}
                  </p>
                </div>
              </div>
            </div>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              id="tabItem"
              className="mainTab"
            >
              <Tab className="mainTabItem" label="Package" value="1" />
              <Tab className="mainTabItem" label="Summary" value="2" />
              <Tab className="mainTabItem" label="Policies" value="3" />
              <div className="flexOne">
                {/* {Object.entries(selectedData).length > 0 && (
                  <ul className="actionIcons makeFlex right appendTop15 appendRight15">
                    <li className="makeFlex perfectCenter cursorPointer">
                      <span className="holidaySprite icon24 share appendRight3"></span>
                      <i
                        className="fa fa-print"
                        aria-hidden="true"
                        style={{ paddingRight: "2px" }}
                      ></i>{" "}
                      {
                        <PDFDownloadLink
                          document={<InvoiceItinerary invoice={itinerarypdf} />}
                          fileName="ItineraryDetails.pdf"
                          style={{
                            fontSize: "12px",
                            color: "#ff0000",
                            fontWeight: "200",
                          }}
                        >
                          {({ blob, url, loading, error }) =>
                            loading
                              ? "Loading document..."
                              : "Download Itinerary"
                          }
                        </PDFDownloadLink>
                      }
                    </li>

                    <li
                      className="makeFlex perfectCenter cursorPointer"
                      onClick={
                        customerDetails == "abc" ? loginPage : openModalShareDiv
                      }
                    >
                      <span className="holidaySprite icon24 share appendRight3"></span>
                      <i
                        className="fa fa-share"
                        aria-hidden="true"
                        style={{ paddingRight: "2px" }}
                      ></i>{" "}
                      Share Plan
                    </li>
                    <li className="makeFlex perfectCenter cursorPointer">
                      <span className="holidaySprite icon24 share appendRight3"></span>
                      {}
                      <div
                        className="add-Itinerary-button"
                        onClick={
                          customerDetails == "abc" ? loginPage : AddToTripPlan
                        }
                      >
                        <span class="holidaySprite activityIcon"></span>Save
                      </div>
                    </li>
                  </ul>
                )} */}
              </div>
            </TabList>
          </div>
        </div>

        <div class="pageContainer makeFlex spaceBetween">
          <div class="leftContainer">
            <div class="left-section">
              <TabPanel value="1">
                <div class="sme-card">
                  <div class="sme-cardTop"></div>
                </div>
                <ul
                  class="initerary-nav "
                  id="initeraryNav"
                  data-testid="itinerary-nav"
                >
                  <li class="active">
                    <b class="appendRight3">{DatesOfDay.length}</b> Day
                    Itinerary
                  </li>
                  <li class="  ">
                    <b class="appendRight3">
                      {Array.isArray(packageData?.accomodation)
                        ? packageData?.accomodation.length
                        : 0}
                    </b>{" "}
                    Hotels
                  </li>
                  <li class="  ">
                    <b class="appendRight3">
                      {Array.isArray(packageData?.landtransfer)
                        ? packageData?.landtransfer.length
                        : 0}
                    </b>{" "}
                    Transfers
                  </li>
                  <li class="  ">
                    <b class="appendRight3">
                      {Array.isArray(packageData?.ferrytransfer)
                        ? packageData?.ferrytransfer.length
                        : 0}
                    </b>{" "}
                    Ferry Transfer
                  </li>
                  <li class=" ">
                    <b class="appendRight3">
                      {Array.isArray(packageData?.attraction)
                        ? packageData?.attraction.length
                        : 0}
                    </b>{" "}
                    Activities
                  </li>
                </ul>
                {tabData.length > 0 && (
                  <VerticalTabsScrollable tabs={tabData} />
                )}
              </TabPanel>
              <TabPanel value="2">
                {summaryTabData.length > 0 && (
                  <Summarydetails summaryTabData={summaryTabData} />
                )}
              </TabPanel>
              <TabPanel value="3">
                {/* <div>
                  <h1>Cancellation Policy</h1>
                </div> */}
                 <Policydetails  policyData={packageData} />
              </TabPanel>
            </div>
          </div>
          <div class="rightContainer">
            <div class="pakageDtlWrap appendBottom20">
              <div class="pakageDtlWrapTop">
                {displayPayment()}
              </div>
              <div class="pakageDtlWrapBottom">
                <div class="pakageDtlRow">
                  <div class="makeFlex appendBottom6">
                    <div class="flexOne makeFlex spaceBetween">
                      <span class="latoBlack">
                        {moment(startDate).format("DD MMM")} -{" "}
                        {moment(endDate).format("DD MMM")}{" "}
                      </span>
                      <Link
                        class="latoBold pointer link link-secondary"
                        onClick={() => handleClear()}
                      >
                        Modify
                      </Link>
                    </div>
                  </div>
                </div>
                {/* {Object.entries(selectedData).length > 0 && (
                  <>
                    <div class="pakageDtlCta" id="continue">
                      <span
                        class="dangerBtn fill btn btn-danger btn-sm"
                        onClick={() => handleItineraryClear()}
                      >
                        Clear To Itinerary
                      </span>
                    </div>

                    <div class="pakageDtlCta" id="continue">
                      <span
                        class="primaryBtn fill btn btn-primary btn-sm"
                        onClick={
                          customerDetails == "abc" ? loginPage : ConfirmBooking
                        }
                      >
                        PROCEED TO BOOK
                      </span>
                    </div>
                  </>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </TabContext>
      <Slider
        id="demoID2"
        animation="zoom"
        speed="fast"
        // closeIcon={(e)=> {setSlideShow(e)}}
        closeIcon={PopuphandleCloseClick}
        toggle={slideShow}
        sliderStyle={{
          width: "900px",
          height: "100%",
          top: "0px",
        }}
        direction="right"
        render={PopupItineraryDetails}
      />
      <Slider
        id="demoID3"
        animation="zoom"
        speed="fast"
        // closeIcon={(e)=> {setSlideShow(e)}}
        closeIcon={PopupExperiencehandleCloseClick}
        toggle={slideExperienceShow}
        sliderStyle={{
          width: "900px",
          height: "100%",
          top: "0px",
        }}
        direction="right"
        render={PopupExperienceItinerary}
      />
      <Slider
        id="demoID4"
        animation="zoom"
        speed="fast"
        // closeIcon={(e)=> {setSlideShow(e)}}
        closeIcon={PopupExperienceTransferhandleCloseClick}
        toggle={slideExperienceTransferShow}
        sliderStyle={{
          width: "900px",
          height: "100%",
          top: "0px",
        }}
        direction="right"
        render={PopupExperienceTransferItinerary}
      />
      <Slider
        id="demoID5"
        animation="zoom"
        speed="fast"
        closeIcon={PopupExperienceTransferFerryhandleCloseClick}
        toggle={slideExperienceTransferFerryShow}
        sliderStyle={{
          width: "900px",
          height: "100%",
          top: "0px",
        }}
        direction="right"
        render={PopupExperienceTransferFerryItinerary}
      />

     
    </div>
  );
  // }
}

export default AdminViewPackageDetails;
